import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GlobalSpinnerStore } from '../../states/global-spinner/global-spinner.store';

@Component({
  selector: 'app-global-spinner',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './global-spinner.component.html',
  styleUrl: './global-spinner.component.scss',
})
export class GlobalSpinnerComponent {
  readonly spinnerStore = inject(GlobalSpinnerStore);
}
